module.exports = __webpack_public_path__ + "media/src/assets/images/comment-manager1-f0b2c1a0cf598227a2572cb2a093381c.png";